export enum WorkloadFetch {
  LIST = 'Workload.LIST',
  DETAIL = 'Workload.DETAIL',
  NAMESPACES = 'Workload.NAMESPACES',
  SECRET_KEYMAP = 'Workload.SECRET_KEYMAP',
  CONFIG_KEYMAP = 'Workload.CONFIG_KEYMAP',
  PERSISTENT_VOLUME_CLAIM = 'Workload.PERSISTENT_VOLUME_CLAIM',
  CUSTER_NODES = 'Workload.CUSTER_NODES',
  GPU_OPTIONS = 'Workload.GPU_OPTIONS',
  REPLICASETS = 'Workload.REPLICASETS',
  MONITOR = 'Workload.MONITOR',
  CONTROLLERRE_VISIONS = 'Workload.ControllerreVisions',
}
